/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectFinancialClaimsDetailsCommandResult } from '../../models/delete-project-financial-claims-details-command-result';

export interface ApiProjectFinancialClaimsDetailsIdDelete$Plain$Params {

/**
 * The ID of the Project Financial Claim Detail to delete.
 */
  id: string;
}

export function apiProjectFinancialClaimsDetailsIdDelete$Plain(http: HttpClient, rootUrl: string, params: ApiProjectFinancialClaimsDetailsIdDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectFinancialClaimsDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialClaimsDetailsIdDelete$Plain.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectFinancialClaimsDetailsCommandResult>;
    })
  );
}

apiProjectFinancialClaimsDetailsIdDelete$Plain.PATH = '/api/ProjectFinancialClaimsDetails/{id}';
